module.exports = __webpack_public_path__ + "img/weikehu.0ae87187.png";